import { render } from "./UtilityReport.vue?vue&type=template&id=38000ea0&scoped=true"
import script from "./UtilityReport.vue?vue&type=script&lang=js"
export * from "./UtilityReport.vue?vue&type=script&lang=js"

import "./UtilityReport.vue?vue&type=style&index=0&id=38000ea0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38000ea0"

export default script